/* Lens option details — rendered INSIDE each result option (owner 2026-09-28: no separate comparison
   tab; each option explains itself; upgrades list clear additional benefits; no catalogue references).

   The option itself is a <button role="radio"> owned by the recommender, so the details panel is placed
   directly after it and styled as its lower half. Clicking the panel selects its option; the
   "Vlerësimet dhe garancia" disclosure only expands. The recommender re-renders the results list,
   so panels are re-attached on every render (MutationObserver).

   Facts (internal source, not shown): FINAL 2026 catalogue — design lines p.10–12, ratings p.03–04,
   warranties p.29–30. Ratings are compared only within one brand's scale. */
(function () {
  "use strict";
  var AT = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  // Progressive designs: rank is meaningful only within the same brand.
  var DESIGNS = [
    { brand: "Ital Lenti", re: /Sky Comfort/, rank: 1, label: "Sky Comfort", text: AT("Vlerë e shkëlqyer: gjeometri Free-Form e optimizuar.") },
    { brand: "Ital Lenti", re: /Premium HV/, rank: 2, label: "Premium HV", text: AT("Personalizim maksimal Free-Form sipas parametrave tuaj, adaptim më i shpejtë.") },
    { brand: "Ital Lenti", re: /Twice Easy/, rank: 3, label: "Twice Easy", text: AT("Maja e gamës Ital Lenti: gjeometri premium, fusha më të gjera shikimi dhe optimizim binokular.") },
    { brand: "Essilor", re: /Liberty 3\.0/, rank: 1, label: "Varilux® Liberty 3.0", text: AT("Niveli hyrës digjital i Varilux®.") },
    { brand: "Essilor", re: /Comfort Max/, rank: 2, label: "Varilux® Comfort Max", text: AT("Komoditet vizual gjatë gjithë ditës, fleksibilitet postural dhe zonë e gjerë leximi.") },
    { brand: "Essilor", re: /Physio extensee/, rank: 3, label: "Varilux® Physio extensee™", text: AT("Mprehtësi edhe në dritë të ulët dhe kalime të buta afër–larg (+18% mprehtësi, +30% kontrast).") },
    { brand: "Essilor", re: /XR Design/, rank: 4, label: "Varilux® XR Design", text: AT("Precizion pavarësisht aktivitetit: korrigjim në çdo distancë dhe shikim i stabilizuar.") },
    { brand: "Essilor", re: /XR Pro/, rank: 5, label: "Varilux® XR Pro", text: AT("Niveli më i lartë i Varilux®: shikim binokular i përsosur dhe lëvizje natyrale e syve.") }
  ];

  function design(lens) {
    if (!lens || lens.vision !== "progressive") return null;
    for (var i = 0; i < DESIGNS.length; i++) {
      if (DESIGNS[i].brand === lens.brand && DESIGNS[i].re.test(lens.family || "")) return DESIGNS[i];
    }
    return null;
  }

  function warranties(lens) {
    var out = [];
    if (!lens) return out;
    var t = String(lens.treatment || "").toUpperCase();
    if (lens.brand === "Essilor") {
      if (design(lens)) out.push(AT("Garanci përshtatjeje Varilux® 60 ditë"));
      if (/CRIZAL|OPTIFOG/.test(t)) out.push(AT("Garanci e trajtimit Crizal® 3 vjet"));
      if (lens.tint === "photochromic") out.push(AT("Garanci e efektit fotokromatik Transitions® 2 vjet"));
      out.push(AT("Premium Satisfaction 2 vjet: çift i ri me 75% zbritje pas dëmtimit mekanik"));
      out.push(AT("Garanci cilësie Essilor 2 vjet"));
    } else if (lens.brand === "Ital Lenti") {
      if (lens.vision === "progressive") out.push(AT("Garanci përshtatjeje për progresivët 30 ditë"));
      if (t === "IRON+") out.push(AT("Garanci e trajtimit IRON+ 3 vjet"));
      else if (/^(HMC\+|ICE|BLUBLOCK|IRON)$/.test(t)) out.push(AT("Garanci e trajtimit 2 vjet"));
    }
    return out;
  }

  function starText(n) { return "★".repeat(n); }

  function gains(lens, base) {
    var S = window.ALGEA_STARS;
    var g = [];
    if (!lens || !base || lens.id === base.id) return g;
    var d = design(lens), bd = design(base);
    if (d && (!bd || bd.brand !== d.brand || d.rank > bd.rank)) g.push(AT("Dizajn ") + d.label + ": " + d.text);
    if (Number(lens.index) > Number(base.index)) {
      g.push(AT("Lente më e hollë: indeks ") + Number(lens.index).toFixed(2) + AT(" (opsioni 1: ") + Number(base.index).toFixed(2) + ")");
    }
    var a = S && S.forLens(lens), b = S && S.forLens(base);
    var before = g.length;
    if (a && a.kind === "stars") {
      if (b && b.kind === "stars" && lens.brand === base.brand) {
        var bm = {};
        b.rows.forEach(function (r) { bm[r.key] = r.score; });
        a.rows.forEach(function (r) {
          if (bm[r.key] == null) g.push(r.label + " (" + starText(r.score) + ")");
          else if (r.score > bm[r.key]) g.push(r.label + ": " + starText(r.score) + AT(" (opsioni 1: ") + starText(bm[r.key]) + ")");
        });
      } else {
        var has = {};
        a.rows.forEach(function (r) { has[r.key] = r.score; });
        var baseFeatures = b && b.kind === "included" ? b.features.join(" ") : "";
        var top = a.rows.filter(function (r) { return r.score >= 5 && r.key !== "blue"; }).map(function (r) { return r.label.toLowerCase(); });
        if (top.length) {
          g.push(AT("Trajtimi ") + AT(lens.treatment) + AT(" me vlerësim të lartë (5★ e më shumë): ") + top.join(", "));
        } else {
          g.push(AT("Trajtimi ") + AT(lens.treatment) + ": " + a.rows.slice(0, 2).map(function (r) {
            return r.label.toLowerCase() + " " + starText(r.score);
          }).join(", ") + AT(" (shkalla e markës deri në ") + a.max + "★)");
        }
        if (has.blue && !/drit[eë] blu|blue light|luce blu/i.test(baseFeatures) && !(b && b.kind === "stars" && b.rows.some(function (r) { return r.key === "blue"; }))) {
          g.push(AT("Mbrojtje nga drita blu"));
        }
      }
    }
    // Same ratings, different treatment (e.g. Crizal Rock → Natural): say what the treatment is for.
    var aboutLens = S ? S.about(lens) : "";
    if (g.length === before && aboutLens && lens.treatment !== base.treatment && aboutLens !== (S ? S.about(base) : "")) {
      g.push(AT("Trajtimi ") + AT(lens.treatment) + ": " + aboutLens.charAt(0).toLowerCase() + aboutLens.slice(1));
    }
    var bw = warranties(base);
    warranties(lens).forEach(function (w) { if (bw.indexOf(w) === -1) g.push(w); });
    return g;
  }

  function panelFor(lens, base, position) {
    var S = window.ALGEA_STARS;
    var box = el("div", "ag-lensinfo");
    box.dataset.lensinfoFor = lens.id;
    box.id = "ag-lensinfo-" + lens.id;

    var d = design(lens);
    var about = S ? S.about(lens) : "";
    var lines = [];
    if (d) lines.push(d.label + " — " + d.text);
    if (about) lines.push(about);
    if (lines.length) box.appendChild(el("p", "ag-lensinfo__about", lines.join(" ")));

    if (position > 0) {
      var list = gains(lens, base);
      if (list.length) {
        var gain = el("div", "ag-lensinfo__gain");
        gain.appendChild(el("p", "ag-lensinfo__gain-title", AT("Çfarë fitoni ndaj opsionit 1")));
        var ul = el("ul", "ag-lensinfo__gain-list");
        list.forEach(function (text) { ul.appendChild(el("li", null, text)); });
        gain.appendChild(ul);
        box.appendChild(gain);
      }
    }

    var facts = S ? S.forLens(lens) : null;
    var warr = warranties(lens);
    if (facts || warr.length) {
      var more = el("details", "ag-lensinfo__more");
      more.appendChild(el("summary", "ag-lensinfo__more-toggle", AT("Vlerësimet dhe garancia")));
      if (facts && facts.kind === "stars") {
        var dl = el("dl", "ag-lensinfo__stars");
        facts.rows.forEach(function (r) {
          var row = el("div", "ag-lensinfo__star-row");
          row.appendChild(el("dt", null, r.label));
          var dd = el("dd", null, starText(r.score));
          dd.setAttribute("aria-label", r.score + AT(" nga ") + facts.max + AT(" yje"));
          row.appendChild(dd);
          dl.appendChild(row);
        });
        more.appendChild(dl);
        if (facts.espf) more.appendChild(el("p", "ag-lensinfo__fine", AT("Mbrojtje UV nga të dyja anët: E-SPF® ") + facts.espf + "."));
        more.appendChild(el("p", "ag-lensinfo__fine", AT("Yjet krahasohen vetëm brenda së njëjtës markë (maksimumi ") + facts.max + ")."));
      } else if (facts && facts.kind === "included") {
        var inc = el("ul", "ag-lensinfo__incl");
        (facts.features.length ? facts.features : [AT("Pa trajtime shtesë")]).forEach(function (f) { inc.appendChild(el("li", null, f)); });
        more.appendChild(inc);
      }
      if (warr.length) {
        more.appendChild(el("p", "ag-lensinfo__warranty-title", AT("Garancia e prodhuesit")));
        var wl = el("ul", "ag-lensinfo__warranty");
        warr.forEach(function (w) { wl.appendChild(el("li", null, w)); });
        more.appendChild(wl);
      }
      box.appendChild(more);
    }
    return box.childNodes.length ? box : null;
  }

  function emptyPanel(lens) {
    var box = el("div", "ag-lensinfo ag-lensinfo--empty");
    box.dataset.lensinfoFor = lens.id;
    box.id = "ag-lensinfo-" + lens.id;
    box.setAttribute("aria-hidden", "true");
    return box;
  }

  function render(results) {
    Array.prototype.forEach.call(results.querySelectorAll(".ag-lensinfo"), function (n) { n.remove(); });
    var cards = results.querySelectorAll("[data-pick]");
    var api = window.ALGEA_RX;
    if (!cards.length || !api) return;
    var lenses = {};
    api.catalogue().forEach(function (lens) { lenses[lens.id] = lens; });
    var base = lenses[cards[0].dataset.pick];
    Array.prototype.forEach.call(cards, function (card, i) {
      var lens = lenses[card.dataset.pick];
      if (!lens) return;
      // W28: every option gets its panel (empty when there is nothing to add), so the side-by-side
      // grid always pairs card + panel and never stacks options when no needs are selected.
      var panel = panelFor(lens, base, i) || emptyPanel(lens);
      card.classList.add("ag-rx-card--with-info");
      card.setAttribute("aria-describedby", panel.id);
      card.insertAdjacentElement("afterend", panel);
    });
    sync(results);
  }

  function sync(results) {
    Array.prototype.forEach.call(results.querySelectorAll(".ag-lensinfo"), function (panel) {
      var card = results.querySelector('[data-pick="' + panel.dataset.lensinfoFor + '"]');
      panel.classList.toggle("ag-lensinfo--selected", !!card && card.getAttribute("aria-checked") === "true");
    });
  }

  function mount(root) {
    Array.prototype.forEach.call(root.querySelectorAll("[data-rx-results]"), function (results) {
      if (results.dataset.lensinfoMounted) return;
      results.dataset.lensinfoMounted = "true";
      var busy = false;
      var observer = new MutationObserver(function () {
  var AT = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };
        if (busy) return;
        busy = true;
        observer.disconnect();
        render(results);
        observer.observe(results, { childList: true });
        busy = false;
      });
      results.addEventListener("click", function (event) {
        var panel = event.target.closest(".ag-lensinfo");
        if (panel && !event.target.closest("summary, details[open], a")) {
          var card = results.querySelector('[data-pick="' + panel.dataset.lensinfoFor + '"]');
          if (card) card.click();
          return;
        }
        if (event.target.closest("[data-pick]")) setTimeout(function () { sync(results); }, 0);
      });
      render(results);
      observer.observe(results, { childList: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { mount(document); }, { once: true });
  } else {
    mount(document);
  }
  document.addEventListener("shopify:section:load", function (event) { mount(event.target); });
}());
